import { render, staticRenderFns } from "./VehiclesBrandDeleteModal.vue?vue&type=template&id=703fa9b8&scoped=true"
import script from "./VehiclesBrandDeleteModal.vue?vue&type=script&lang=js"
export * from "./VehiclesBrandDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./VehiclesBrandDeleteModal.vue?vue&type=style&index=0&id=703fa9b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703fa9b8",
  null
  
)

export default component.exports